import styles from './PageTemplate.module.css';

export const PageTemplate = ({
  children,
  NavBar,
  SecondaryNavBar,
}: {
  children: React.ReactNode;
  NavBar: React.ComponentType;
  SecondaryNavBar?: React.ComponentType;
}) => {
  return (
    <>
      <header className={styles.AppHeader}>
        <NavBar />
        {SecondaryNavBar ? <SecondaryNavBar /> : null}
      </header>
      <main className={styles.AppMain}>{children}</main>
    </>
  );
};
